<ul class="breadcrumbs mb-4" >
  <li *ngIf="consumer">
    <a routerLink="/">Strona główna</a>
  </li>
  <li *ngIf="!consumer">
    <a routerLink="/biznes">Strona główna</a>
  </li>


  <li *ngFor="let item of items">
    <a *ngIf="item.link" [routerLink]="item.link">
      {{ item.name }}
    </a>
    <ng-container *ngIf="!item.link">
      {{ item.name }}
    </ng-container>
  </li>
</ul>
